module.exports = __webpack_public_path__ + "img/9791195718733.016bd93d.jpg";